export default {
  env: 'production',
  cookie: 'md-noticejs-sticky-',
  domain: 'mdirector.com',
};



/** WEBPACK FOOTER **
 ** ./src/environments/production.js
 **/